import { AddSpaceButton } from "@/react/components/Spaces/SidebarV2/CommunityMenu/SpaceList/AddSpaceButton";
import { JoinSpacesButton } from "@/react/components/Spaces/SidebarV2/CommunityMenu/SpaceList/JoinSpacesButton";
import { canCreateSpaces } from "@/react/helpers/spaceGroupHelpers";
import type { SpaceGroup } from "@circle-react/types";

export interface BottomButtonProps {
  spaceGroup: SpaceGroup;
}

export const BottomButton = ({ spaceGroup }: BottomButtonProps) => {
  if (canCreateSpaces({ spaceGroup })) {
    return <AddSpaceButton spaceGroupId={spaceGroup.id} />;
  }

  if (spaceGroup.hide_non_member_spaces_from_sidebar) {
    return <JoinSpacesButton spaceGroupSlug={spaceGroup.slug} />;
  }

  return null;
};
